<template>
  <VDialog v-model="show" persistent max-width="1200px">
    <VForm ref="formVDialog">
      <LoadingDialog ref="Loading"/>
      <VCard class="pa-1">
        <VCardTitle class="title">Signatários</VCardTitle>
        <VCardText>
          <VLayout v-show="!bloquearInsercao" row wrap class="pa-2" justify-space-around>
            <VFlex md3>
              <VTextField label="Nome"
                          prepend-icon="account_box"
                          v-model="signatario.nome"
                          :rules="[rules.tamanho(50), rules.obrigatorio(true)]"
              ></VTextField>
            </VFlex>
            <VFlex md3>
              <VTextField label="E-mail"
                          prepend-icon="mail"
                          v-model="signatario.email"
                          :rules="[rules.tamanho(50), rules.obrigatorio(true), rules.email]"
              ></VTextField>
            </VFlex>
            <VFlex md2>
              <VSelect label="Ação"
                       prepend-icon="list"
                       v-model="signatario.acao"
                       menu-props="auto"
                       item-value="id"
                       item-text="acao"
                       return-object
                       :items="acoes"
                       :rules="[rules.obrigatorio(true)]"></VSelect>
            </VFlex>
            <VFlex md2 pl-4>
              <VCheckbox
                label="Presencial"
                v-model="signatario.isPresencial"
                hide-details
                color="primary"/>
            </VFlex>
            <VFlex md2>
              <VBtn :disabled="bloquearInsercao" color="primary" @click="adicionarSignatario">
                <VIcon>add</VIcon>
              </VBtn>
            </VFlex>
          </VLayout>
          <VContainer ma-0 pa-1>
            <VDataTable :items="signatarios" :headers="cabecalhosSignatarios"
                        no-data-text="Nenhum signatário vinculado ao documento">
              <template v-slot:items="props">
                <tr>
                  <td>
                    <VIcon :color="props.item.assinado ? 'green' : 'red'">check</VIcon>
                  </td>
                  <td v-if="props.item.nome != null && props.item.nome !== ''">{{ props.item.nome }}</td>
                  <td v-else style="font-style: italic;color: gray">Usuário sem cadastro na D4Sign</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ acoes[props.item.acao.id - 1].acao }}</td>
                  <td style="padding-left: 26px">
                    {{ props.item.isPresencial ? 'Presencial' : 'Email' }}
                  </td>
                  <td>
                    <VTooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <VBtn v-show="props.item.isPresencial"
                              :disabled="!props.item.isPresencial || props.item.assinado" color="primary" v-bind="attrs"
                              v-on="on" @click="mostrarDialogAssinatura(props.item)">
                          <VIcon>admin_panel_settings</VIcon>
                        </VBtn>
                      </template>
                      <span>Inserir assinatura presencial.</span>
                    </VTooltip>
                    <BotaoExcluir :disabled="signatarios.length === 1 || props.item.assinado" color="primary"
                                  @click="excluirSignatario(props)"/>
                  </td>
                </tr>
              </template>
            </VDataTable>
          </VContainer>
        </VCardText>
        <VCardActions>
          <VBtn @click="fechar" block :disabled="requisicaoEmAndamento">Fechar</VBtn>
        </VCardActions>
      </VCard>
    </VForm>
    <AssinaturaPresencial :visible="telaAssinaturaPresencial" :item="itemSelecionado" @close="atualizarAssinaturas"/>
  </VDialog>
</template>
<script>
import forms from '@/common/forms';
import alerts from '@/common/alerts'
import LoadingDialog from '@/components/Dialog/Loading.vue';
import BotaoExcluir from "../Botoes/BotaoExcluir";
import ApiService from "@/common/api.service";
import AssinaturaPresencial from "@/components/Dialog/AssinaturaPresencial";
import {mapState} from "vuex";

export default {
  name: "Signatarios",
  components: {LoadingDialog, BotaoExcluir, AssinaturaPresencial},
  props: ['visible', 'item', 'docType'],
  computed: {
    ...mapState(['parametros']),
    possuiSignatariosPadroes() {
      var possuiSignatariosPadroes = false;
      let configuracao = this.$store.state.parametros.configuracoes;

      if (configuracao != null) {
        if (configuracao.assinaturaDigital != null) {
          let assinatura = configuracao.assinaturaDigital;
          possuiSignatariosPadroes = assinatura.signatarios.length > 0;
        }
      }
      return possuiSignatariosPadroes;
    },
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    registro: {
      get() {
        return this.item
      },
      set(value) {
        this.item = value
      }
    },
    tpDoc: {
      get() {
        return this.docType
      },
      set(value) {
        this.docType = value
      }
    }
  },
  watch: {
    async show(value) {
      if (value) {
        await this.limparFormulario();
        await this.buscarAcoes();
        await this.abrir();
      }
    }
  },
  data() {
    return this.dadosIniciais()
  },
  methods: {
    limparFormulario() {
      Object.assign(this.signatario, this.dadosIniciais().signatario);
      Object.assign(this.signatarios, this.dadosIniciais().signatarios);
      this.$refs.formVDialog.resetValidation();
    },
    dadosIniciais() {
      return {
        itemSelecionado: {},
        telaAssinaturaPresencial: false,
        bloquearInsercao: false,
        codigoComanda: null,
        acoes: [{
          id: null,
          acao: null
        }],
        signatarios: [],
        requisicaoEmAndamento: false,
        rules: forms.rules,
        cabecalhosSignatarios: [
          {
            text: '',
            value: 'assinado',
            filterable: false
          },
          {
            text: 'Nome',
            value: 'nome',
            filterable: false
          },
          {
            text: 'Email',
            value: 'email',
            filterable: false
          },
          {
            text: 'Ação',
            value: 'acao',
            filterable: false
          },
          {
            text: 'Tipo assinatura',
            value: 'presencial',
            filterable: false
          },
          {
            text: 'Comandos',
            value: 'comandos'
          },
        ],
        signatario: {
          id: null,
          nome: null,
          email: null,
          isPresencial: false,
          acao: {
            id: 1,
            acao: 'Assinar'
          },
          assinado: false,
          linkAssinaturaPresencial: "",
          chave: ""
        },
        acaoPadrao: {
          id: 1,
          acao: 'Assinar'
        }
      }
    },
    async adicionarSignatario() {
      let emailRepetido = false;
      this.signatarios.forEach((s) => {
        if (s.email === this.signatario.email) {
          emailRepetido = true;
        }
      });

      if (emailRepetido) {
        alerts.exibirErro('Email duplicado', 'Lista de signatários já possui o email: ' + this.signatario.email + ' cadastrado');
      } else {
        if (this.$refs.formVDialog.validate()) {
          let signatario = {
            nome: this.signatario.nome,
            email: this.signatario.email,
            acao: {
              id: this.signatario.acao.id,
              acao: this.signatario.acao.acao
            },
            isPresencial: this.signatario.isPresencial
          }

          let addOK = false;
          await this.addSignatario(signatario).then((obj) => {
            if (obj != null) {
              signatario.linkAssinaturaPresencial = obj.data.message[0].assinatura_presencial_link;
              if (obj.status === 200) {
                addOK = true;
              }
            }
          });

          if (addOK) {
            this.signatarios.push(signatario);
            this.signatario.nome = null;
            this.signatario.email = null;
            this.signatario.acao = this.acaoPadrao;
            this.signatario.isPresencial = false;
            this.$refs.formVDialog.resetValidation();
          }
        }
      }
      await this.atualizarAssinaturas();
    },
    async abrir() {

      this.limparFormulario();

      if(await this.disponibilidadeAPI()){
        let isNovoRegistro = this.registro.chave == null || this.registro.chave === "";

        if (this.tpDoc === "Ficha") {
          await this.processaFicha(isNovoRegistro);
        } else {
          await this.processaContrato(isNovoRegistro);
        }
      } else {
        await alerts.exibirErro("Falha ao acessar D4Sign", "API D4Sign indisponível, favor tentar novamente mais tarde.");
      }

    },
    async fechar() {
      this.$emit('close', false);
    },
    async disponibilidadeAPI() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.get(`assinatura/disponibilidade`)]);
        return respostas != null &&
               respostas[0] != null &&
               respostas[0].data != null ? respostas[0].data : false;
      } catch (e) {
        await alerts.exibirErro("Falha ao acessar D4Sign", "API D4Sign indisponível, favor tentar novamente mais tarde." + e);
      }
    },
    async processaFicha(isNovoRegistro){
      this.registro.chave = isNovoRegistro ? await this.consultaSeFichaPossuiChave() : this.registro.chave;
      isNovoRegistro = this.registro.chave == null || this.registro.chave === "";

      if (isNovoRegistro) {
        this.registro.chave = await this.uploadFichaD4Sign();
        if (this.possuiSignatariosPadroes) {
          if(this.registro.chave) {
            await this.vincularSignatariosPadroesEEnviaDocumentoParaAssinatura();
          } else {
            await alerts.exibirErro('Não foi possível fazer o upload da ficha', 'O sistema realizou a tentativa de upload do arquivo, porém a D4Sign não gerou o identificador do documento.');
          }
        }
      } else {
        await this.carregarListaSignatarios();
      }
    },
    async processaContrato(isNovoRegistro){
      if (isNovoRegistro) {
        this.registro.chave = await this.uploadContratoD4Sign();
        if (this.possuiSignatariosPadroes) {
          if(this.registro.chave) {
            await this.vincularSignatariosPadroesEEnviaDocumentoParaAssinatura();
          } else {
            await alerts.exibirErro('Não foi possível fazer o upload do contrato', 'O sistema realizou a tentativa de upload do arquivo, porém a D4Sign não gerou o identificador do documento.');
          }
        }
      } else {
        await this.carregarListaSignatarios();
      }
    },
    async consultaSeFichaPossuiChave() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.get(`assinatura/consultaChaveFicha/${this.registro.idFormularioPreenchido}`)], "Realizando consulta por chave da ficha.");
        return respostas[0].data;
      } catch (e) {
        await alerts.exibirErro('Não foi possível fazer o upload da ficha', e);
      }
      return false;
    },
    async uploadFichaD4Sign() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.post(`assinatura/uploadFicha/${this.registro.idFormularioPreenchido}`, {})], "Realizando upload de ficha na D4Sign.");
        return respostas[0].data;
      } catch (e) {
        await alerts.exibirErro('Não foi possível fazer o upload da ficha. ', 'Revisar a configuração de assinatura na agenda 2.0 e o limite de envios do seu cofre na D4Sign. '+e);
      }
    },
    async uploadContratoD4Sign() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.post(`assinatura/uploadContrato/${this.registro.idVenda}`, {})], "Realizando upload de contrato na D4Sign.");
        return respostas[0].data;
      } catch (e) {
        await alerts.exibirErro('Não foi possível fazer o upload do contrato', 'Revisar a configuração de assinatura na agenda 2.0 e o limite de envios do seu cofre na D4Sign. '+e);
      }
    },
    async vincularSignatariosPadroes() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.post(`assinatura/vincularSignatariosPadroes/${this.registro.chave}`, {})], "Vinculando signatários padrões");
        return respostas[0];
      } catch (e) {
        await alerts.exibirErro('Não foi possível vincular signatarios padrões ao contrato', e);
      }
    },
    async vincularSignatariosPadroesEEnviaDocumentoParaAssinatura() {
      let vincularOK = false;
      await this.vincularSignatariosPadroes().then((r) => {
        if (r.status === 200 && r.data.message != null) {
          vincularOK = true;
        }
      });

      if (vincularOK) {
        let enviarAssinaturaOK = false;
        await this.enviarContratoParaAssinatura().then((en) => {
          if (en.status === 200) {
            enviarAssinaturaOK = true;
          }
        });

        if (enviarAssinaturaOK) {
          let buscarSignatariosOK = false;
          await this.buscarSignatarios().then((b) => {
            if (b.status === 200) {
              buscarSignatariosOK = true;
              this.signatarios = b.data.signatarios;
              this.bloquearInsercao = b.data.resultado.statusName === "Finalizado";
            }
          });

          if (buscarSignatariosOK && this.show === false) {
            this.show = true;
          }
        }
      }
    },
    async carregarListaSignatarios() {
      let buscarSignatariosOK = false;
      await this.buscarSignatarios().then((b) => {
        if (b.status === 200) {
          buscarSignatariosOK = true;
          if (b.data != null) {
            this.signatarios = b.data.signatarios;
            this.bloquearInsercao = b.data.resultado.statusName === "Finalizado";
          }
        }
        if (buscarSignatariosOK && this.show === false) {
          this.show = true;
        }
      }).catch((c) => {
        alerts.exibirErro('Não foi possível buscar signatários', c);
      });
    },
    async addSignatario(signatario) {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.post(`assinatura/signatarios/${this.registro.chave}`, signatario)], "Adicionando signatário.");
        return respostas[0];
      } catch (e) {
        await alerts.exibirErro("Falha ao adicionar signatário", "Email inválido. " + e);
      }
    },
    async removeSignatario(signatario) {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.delete(`assinatura/signatarios/${this.registro.chave}/${signatario.chave}/${signatario.email}`)], "Removendo signatário.");
        return respostas[0];
      } catch (e) {
        await alerts.exibirErro('Não foi possível remover signatário', e);
      }
    },
    async excluirSignatario(linha) {
      if (await this.alertarMudancaStatusDocumento()) {
        if (!await alerts.pedirConfirmacao(
          'Excluir último signatário pendente?',
          'Ao excluir o último signatário com assinatura pendente, automaticamente o status do documento será alterado para FINALIZADO, ' +
          'e não será mais possível alterar os signatários.')) {
          return;
        }
        this.bloquearInsercao = true;
      }

      let removeOK = false;
      await this.removeSignatario(linha.item).then(() => {
        removeOK = true
      }).catch((e) => {
        alerts.exibirErro('Não foi possível remover signatário', e)
      });
      if (removeOK) {
        this.signatarios = this.signatarios.filter((obj) => {
          return obj.email !== linha.item.email;
        });
      }
    },
    async buscarAcoes() {
      try {
         this.acoes = [
                        {
                          "id": 1,
                          "acao": "Assinar"
                        },
                        {
                          "id": 2,
                          "acao": "Aprovar"
                        },
                        {
                          "id": 3,
                          "acao": "Reconhecer"
                        },
                        {
                          "id": 4,
                          "acao": "Assinar como parte"
                        },
                        {
                          "id": 5,
                          "acao": "Assinar como testemunha"
                        },
                        {
                          "id": 6,
                          "acao": "Assinar como interveniente"
                        },
                        {
                          "id": 7,
                          "acao": "Acusar recebimento"
                        },
                        {
                          "id": 8,
                          "acao": "Assinar como Emissor, Endossante e Avalista"
                        },
                        {
                          "id": 9,
                          "acao": "Assinar como Emissor, Endossante, Avalista, Fiador"
                        },
                        {
                          "id": 10,
                          "acao": "Assinar como fiador"
                        },
                        {
                          "id": 11,
                          "acao": "Assinar como parte e fiador"
                        },
                        {
                          "id": 12,
                          "acao": "Assinar como responsável solidário"
                        },
                        {
                          "id": 13,
                          "acao": "Assinar como parte e responsável solidário"
                        }
                      ];
      } catch (e) {
        await alerts.exibirErro("Não foi possível buscar as ações para assinatura", e);
      }
    },
    async enviarContratoParaAssinatura() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.post(`assinatura/enviarContratoParaAssinatura/${this.registro.chave}`, {})]);
        return respostas[0];
      } catch (e) {
        await alerts.exibirErro('Não foi possível enviar documento para assinatura', e);
      }
    },
    async buscarSignatarios() {
      try {
        const respostas = await this.enviarEAguardarBackend([ApiService.get(`assinatura/signatarios/${this.registro.chave}`)]);
        return respostas[0];
      } catch (e) {
        await alerts.exibirErro('Não foi possível buscar os signatários do documento', e);
      }
    },
    async enviarEAguardarBackend(promises, texto) {
      try {
        this.requisicaoEmAndamento = true;
        return await this.$refs.Loading.aguardarPromises(promises, texto);
      } finally {
        this.requisicaoEmAndamento = false;
      }
    },
    async alertarMudancaStatusDocumento() {
      let qtdSignatarios = this.signatarios.length;
      let qtdAssinados = 0;
      this.signatarios.forEach((sign) => {
        if (sign.assinado) {
          qtdAssinados++;
        }
      });

      return qtdAssinados > 0 && (qtdSignatarios - 1) === qtdAssinados;
    },
    async mostrarDialogAssinatura(item) {
      if(this.signatarios.length === 1){
        if (await alerts.pedirConfirmacao("Alteração de status do documento", "Se houverem mais signatários para serem inseridos no documento, é indicado primeiramente fazer a inserção de todos os signatários, e depois realizar as assinaturas presenciais. Caso o documento seja assinado com apenas um signatário, ao realizar esta assinatura, o status do documento será automaticamente alterado para 'Finalizado'. Deseja confirmar?")) {
          this.itemSelecionado = item;
          this.telaAssinaturaPresencial = !this.telaAssinaturaPresencial;
        }
      } else {
        this.itemSelecionado = item;
        this.telaAssinaturaPresencial = !this.telaAssinaturaPresencial;
      }
    },
    async atualizarAssinaturas() {
      this.telaAssinaturaPresencial = false;
      await this.buscarSignatarios().then((b) => {
        if (b.status === 200) {
          this.signatarios = b.data.signatarios;
          this.bloquearInsercao = b.data.resultado.statusName === "Finalizado";
        }
      });
    }
  },
}
</script>

<style scoped>

</style>
